import React from "react";
import { NoSettings } from "./sectionFormKit";

// Customer: components/sections/GuestOrder/GuestOrder.js
const GuestOrder = () => <NoSettings text="Order lookup for guests. No settings." />;

export default GuestOrder;
